aztech.use(function (pkg) {


    'use strict';


    pkg.factoryManager.get('app').create({
        name: 'footer',
        version: '0.0.1',
        dependencies: [
            'mod.vue',
            'app.iconsBase',
            'app.iconsSocial',
            'app.iconsProducts'
        ],
        templates: {
            footer: `<div class="user-logged-footer" v-if="isLogged">
    <div class="about">
        <p class="copyright">
            Copyright © {{ year }} Azion Technologies. All rights reserved. &nbsp;|&nbsp; 
            <a href="https://www.azion.com/en/documentation/agreements/privacy-policy/">Legal & Privacy</a>
        </p>
    </div>
</div>
<div class="wrapper" v-else>
    <div class="info">
        <ul class="network">
            <li>
                <a class="icon icon-22 icon-facebook" target="_blank" href="https://www.facebook.com/aziontech"></a>
            </li>
            <li>
                <a class="icon icon-22 icon-twitter" target="_blank" href="https://twitter.com/aziontech"></a>
            </li>
            <li>
                <a class="icon icon-22 icon-linkedin" target="_blank" href="https://www.linkedin.com/company/aziontech"></a>
            </li>
            <li>
                <a class="icon icon-22 icon-instagram" target="_blank" href="https://www.instagram.com/aziontech"></a>
            </li>
        </ul>

        <div class="contact">
            <p>For Sales we are available at <span> +1 (833) 33-AZION </span></p>
            <p>If you need Support do not hesitate to call us at <span> +1 (833) 33-AZION </span></p>
        </div>
    </div>

    <div class="info">
        <ul class="jobs-and-terms">
            <li><a class="link link-l4" href="https://jobs.azion.com/">Work at Azion</a></li>
            <li><a class="link link-l4"href="https://www.azion.com/en/documentation/agreements/privacy-policy/">Privacy Policy</a></li>
        </ul>
        <p class="copyright">Copyright © {{ year }} Azion Technologies.<br>All rights reserved.</p>
    </div>
</div>`,
            linkedinAdsTag: `
_linkedin_partner_id = "2231809";
window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
window._linkedin_data_partner_ids.push(_linkedin_partner_id);
(function(){var s = document.getElementsByTagName("script")[0];
var b = document.createElement("script");
b.type = "text/javascript";b.async = true;
b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
s.parentNode.insertBefore(b, s);})();`,
            linkedinAdsTagSecondary: `_linkedin_partner_id = "2016922";
window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
window._linkedin_data_partner_ids.push(_linkedin_partner_id);

(function(){var s = document.getElementsByTagName("script")[0];
var b = document.createElement("script");
b.type = "text/javascript";b.async = true;
b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
s.parentNode.insertBefore(b, s);})();`,
            googleAdsTag: `window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());
gtag('config', 'AW-707925660');
`,
            googleAdsTagSecondary: `window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());
gtag('config', 'AW-645189257');`,
            segmentTag: `!function(){var analytics=window.analytics=window.analytics||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error("Segment snippet included twice.");else{analytics.invoked=!0;analytics.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","once","off","on","addSourceMiddleware","addIntegrationMiddleware","setAnonymousId","addDestinationMiddleware"];analytics.factory=function(e){return function(){var t=Array.prototype.slice.call(arguments);t.unshift(e);analytics.push(t);return analytics}};for(var e=0;e<analytics.methods.length;e++){var key=analytics.methods[e];analytics[key]=analytics.factory(key)}analytics.load=function(key,e){var t=document.createElement("script");t.type="text/javascript";t.async=!0;t.src="https://cdn.segment.com/analytics.js/v1/" + key + "/analytics.min.js";var n=document.getElementsByTagName("script")[0];n.parentNode.insertBefore(t,n);analytics._loadOptions=e};analytics._writeKey="$TOKEN_PLACEHOLDER";analytics.SNIPPET_VERSION="4.13.2";
analytics.load("$TOKEN_PLACEHOLDER");
}}();
`,
            clarityTag: `(function(c,l,a,r,i,t,y){
    c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
    t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
    y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
})(window, document, "clarity", "script", "$TOKEN_PLACEHOLDER");
`,
        },
        setup: function (__shared) {
            return __shared;
        },
        init: function (data, __shared) {
            let PUBLIC = {};
            let Vue = __shared.dependencies['mod.vue'];
            let segmentToken = "KCNzDl8Zfv9kctcq3jzIbbOHnaq3DbAz";
            let clarityToken = "hs0g4f9tq4";
            const ssoHost =  data.ssoHost || window.origin;

            PUBLIC.component = Vue.component('az-footer', {
                template: __shared.templates.footer,
                data: function () {
                    return {
                        isLogged: data.isLogged,
                        trackingTraits: data.trackingTraits || {},
                        year: new Date().getFullYear(),
                        listeners: [],
                        userInfoEndpoint: `${ssoHost}/api/user/me`,
                        clientId: null,
                        initialFormData: {},
                        comparatorMap: {
                            isEqual: (oldValue, newValue) => oldValue === newValue,
                            isDisabled: (oldValue, newValue) => !Boolean(newValue),
                            isEmpty: (oldValue, newValue) => !Boolean(newValue)
                        }
                    };
                },
                async created() {
                    if (this.isLogged) {
                        const { client_id, id } = await this.getUserInfo(); // jshint ignore:line
                        this.clientId = client_id; // jshint ignore:line

                        window.analytics.identify(`${id}`);
                        window.analytics.page();
                    }
                },
                mounted() {
                    setTimeout(() => {
                        this.trackDOM();
                    }, 600);

                    document.body.addEventListener("trackingLoad", () => {
                        this.trackDOM();
                    });

                    document.body.addEventListener("track", ({ detail }) => {
                        this.runTracking(detail);
                    });
                },
                methods: {
                    updateFooter: function () {
                        const main = document.querySelector('[root]');
                        if (main) {
                            if (this.isLogged) {
                                main.classList.add('logged');
                            } else {
                                main.classList.remove('logged');
                            }
                        }
                    },
                    trackDOM() {
                        for (const listener of this.listeners) {
                            const { el, event, func } = listener;
                            el.removeEventListener(event, func);
                        }

                        this.trackPages();
                        this.trackClicks();
                        this.trackSwitchs();
                        this.trackSubmits();
                        this.trackForms();

                        this.initialFormData = this.getEventAndFormData()[1];
                    },
                    trackPages() {
                        const pages = document.querySelectorAll("[data-tracking-page]");

                        for (const page of pages) {
                            if (window.analytics) {
                                const [trackEvent, trackProps] = this.getEventAndProps(page, 'page');

                                if (this.isEmpty(trackEvent)) {
                                    continue;
                                }

                                window.analytics.track(`Page ${trackEvent}`, trackProps);
                            }
                        }
                    },
                    trackClicks() {
                        const clickables = document.querySelectorAll("[data-tracking-click]");

                        for (const link of clickables) {
                            const clickLink = () => {
                                if (window.analytics) {
                                    const [trackEvent, trackProps] = this.getEventAndProps(link, 'click');

                                    if (this.isEmpty(trackEvent)) {
                                        return;
                                    }

                                    window.analytics.track(`Click ${trackEvent}`, trackProps);
                                }
                            };

                            link.addEventListener("click", clickLink, { once: true });
                            this.listeners.push({ el: link, event: "click", func: clickLink });
                        }
                    },
                    trackSwitchs() {
                        const inputs = document.querySelectorAll("[data-tracking-switch]");

                        for (const input of inputs) {
                            const changeSwitch = (event) => {
                                if (window.analytics) {
                                    const [trackEvent, trackProps] = this.getEventAndProps(input, 'switch');

                                    if (this.isEmpty(trackEvent)) {
                                        return;
                                    }

                                    const checkedLabel = event.target.checked ? 'Enable' : 'Disable';
                                    window.analytics.track(`${checkedLabel} ${trackEvent}`, trackProps);
                                }
                            };

                            input.addEventListener("change", changeSwitch);
                            this.listeners.push({ el: input, event: "change", func: changeSwitch });
                        }
                    },
                    trackSubmits() {
                        const forms = document.querySelectorAll("[data-tracking-submit]");

                        for (const form of forms) {
                            const trackingSubmitSuccess = () => {
                                if (window.analytics) {
                                    const [trackEvent, trackProps] = this.getEventAndProps(form, 'submit');

                                    if (this.isEmpty(trackEvent)) {
                                        return;
                                    }

                                    window.analytics.track(trackEvent, trackProps);
                                }
                            };

                            const trackingSubmitFail = () => {
                                if (window.analytics) {
                                    const [trackEvent, trackProps] = this.getEventAndProps(form, 'submit-fail');

                                    if (this.isEmpty(trackEvent)) {
                                        return;
                                    }

                                    window.analytics.track(trackEvent, trackProps);

                                }
                            };

                            form.addEventListener("trackingSubmitSuccess", trackingSubmitSuccess);
                            form.addEventListener("trackingSubmitFail", trackingSubmitFail);

                            this.listeners.push({ el: form, event: "trackingSubmitSuccess", func: trackingSubmitSuccess });
                            this.listeners.push({ el: form, event: "trackingSubmitFail", func: trackingSubmitFail });
                        }
                    },
                    trackForms () {
                        const button = document.querySelector("[data-tracking-submit-button]");
                        if (!button) return

                        const trackingForm = () => {
                            if (window.analytics) {
                                const [trackEvent, finalFormData, trackFormFields, instanceId] = this.getEventAndFormData();
                                let trackProps = this.parseFormData(this.initialFormData, finalFormData, trackFormFields, instanceId);

                                if (this.isEmpty(trackEvent)) {
                                    return;
                                }

                                window.analytics.track(trackEvent, trackProps);
                            }
                        };

                        button.addEventListener("click", trackingForm);
                    },
                    parseFormData(oldFormState, newFormState, trackFormFields, instanceId) {
                        var props = {}
                        for (const key in trackFormFields) {
                            const {field, comparator, values} = trackFormFields[key]
                            const comparatorFunction = this.comparatorMap[comparator]
                            const valueIndex = comparatorFunction(oldFormState[field], newFormState[field]) ? 1 : 0
                            props[key] = values[valueIndex]
                        }
                        props.id = instanceId
                        props = this.mountProps(props)

                        return props
                    },
                    getEventAndFormData() {
                        /*
                            Example of data-tracking-form-fields:
                            {
                                "name_changed": {"field": "name", "comparator":"isEqual", "values": ["yes", "no"]},
                                "active": {"field": "is_active", "comparator":"isDisabled", "values": ["yes", "no"]},
                            };
                        */

                        let formData = {}
                        let trackFormFields = {}
                        let trackEvent = ''
                        let instanceId;
                        const forms = document.querySelectorAll("[data-tracking-form]");

                        for (const form of forms) {
                            instanceId = form.getAttribute(`data-tracking-form-instance-id`) || instanceId;
                            trackEvent = form.getAttribute(`data-tracking-form`) || trackEvent;
                            var tmpTrackFormFields = form.getAttribute(`data-tracking-form-fields`) || "{}";
                            trackFormFields = {...trackFormFields, ...JSON.parse(tmpTrackFormFields)}
                            var tmpForm = new FormData(form)
                            formData = {...formData, ...Object.fromEntries(tmpForm)}
                        }

                        return [trackEvent, formData, trackFormFields, instanceId]
                    },
                    /**
                     * @description This parse will return a object from param props.
                     * @param {String} props Ex: "bar: 1, foo: '2'"
                     * @returns Object
                     */
                    parseTrackProps(props) {
                        let trackProps = {};

                        if (props) {
                            trackProps = props.split(",");
                            trackProps = trackProps.map((props) => {
                                if (props.trim()) {
                                    let [key, value] = props.split(":");
                                    value = value.trim().replaceAll("'", "");
                                    value = value.replaceAll('"', '');
                                    value = this.isNumeric(value) ? Number(value) : value;
                                    return { [key.trim()]: value };
                                }
                            });
                            trackProps = trackProps.filter(prop => prop !== undefined);
                            trackProps = trackProps.reduce((next, current) => {
                                return Object.assign({}, next, current);
                            });
                        }

                        return trackProps;
                    },
                    getEventAndProps(el, attrName) {
                        const trackEvent = el.getAttribute(`data-tracking-${attrName}`);

                        let trackProps = el.getAttribute("data-tracking-props");
                        trackProps = this.parseTrackProps(trackProps);
                        trackProps = this.mountProps(trackProps);

                        return [trackEvent, trackProps];
                    },
                    mountProps(props = {}) {
                        props.origin = 'UI';

                        if (this.clientId) {
                            props.client_id = this.clientId; // jshint ignore:line
                        }

                        return props;
                    },
                    runTracking(params) {
                        let { name, props } = params;

                        if (window.analytics && name) {
                            props = this.mountProps(props);
                            window.analytics.track(name, props);
                        }
                    },
                    isEmpty(text) {
                        return text === null || text === undefined || (typeof text === "string" && text.trim() === "");
                    },
                    /**
                     *
                     * @param {String} str
                     * @returns Boolean
                     */
                    isNumeric(str) {
                        // Snippet from: https://stackoverflow.com/questions/175739/built-in-way-in-javascript-to-check-if-a-string-is-a-valid-number
                        return !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
                            !isNaN(parseFloat(str)); // ...and ensure strings of whitespace fail
                    },
                    async getUserInfo() {
                        const options = {
                            method: 'GET',
                            credentials: 'include',
                            headers: {
                                'Accept': 'application/json; version=1',
                                'Content-Type': 'application/json;charset=UTF-8',
                            },
                        };

                        try {
                            const response = await fetch(this.userInfoEndpoint, options);
                            const { results } = await response.json();
                            return results;
                        } catch (error) {
                            console.error(error);
                            return {};
                        }
                    }
                },
                watch: {
                    isLogged: function () {
                        this.updateFooter();
                    }
                },
                beforeMount() {
                    this.updateFooter();
                    let scriptTag = document.createElement("script");
                    let scriptTagAsync = document.createElement("script");
                    let scriptTagAsyncGoogleAd = document.createElement("script");
                    scriptTagAsync.setAttribute("async", "");
                    scriptTagAsync.src = "https://www.googletagmanager.com/gtag/js?id=AW-707925660";
                    scriptTagAsyncGoogleAd.setAttribute("async", "");
                    scriptTagAsyncGoogleAd.src = "https://www.googletagmanager.com/gtag/js?id=AW-645189257";
                    scriptTag.innerHTML += __shared.templates.linkedinAdsTag;
                    scriptTag.innerHTML += __shared.templates.linkedinAdsTagSecondary;
                    scriptTag.innerHTML += __shared.templates.googleAdsTag;
                    scriptTag.innerHTML += __shared.templates.googleAdsTagSecondary;

                    if (segmentToken && segmentToken !== "undefined") {
                        scriptTag.innerHTML += __shared.templates.segmentTag.replaceAll("$TOKEN_PLACEHOLDER", segmentToken);
                    }

                    if (clarityToken && clarityToken !== "undefined") {
                        scriptTag.innerHTML += __shared.templates.clarityTag.replaceAll("$TOKEN_PLACEHOLDER", clarityToken);
                    }

                    document.body.appendChild(scriptTagAsync);
                    document.body.appendChild(scriptTagAsyncGoogleAd);
                    document.body.appendChild(scriptTag);
                }
            });

            PUBLIC.app = new Vue({
                el: '.az-footer',
            });

            return PUBLIC;
        }
    });
});
